function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createSelector } from 'reselect';
import { Utils } from 'manifesto.js/dist-esmodule/Utils';
import CanvasGroupings from '../../lib/CanvasGroupings';
import { getManifestoInstance } from './manifests';
import { getWindow, getWindowViewType } from './windows';
export var getCanvases = createSelector([getManifestoInstance], function (manifest) {
  return manifest && manifest.getSequences()[0].getCanvases();
});
/**
* Return the canvas selected by an index
* @param {object} state
* @param {object} props
* @param {string} props.manifestId
* @param {string} props.windowId
* @return {Object}
*/

export var getCanvas = createSelector([getManifestoInstance, function (state, _ref) {
  var canvasIndex = _ref.canvasIndex;
  return canvasIndex;
}, function (state, _ref2) {
  var canvasId = _ref2.canvasId;
  return canvasId;
}], function (manifest, canvasIndex, canvasId) {
  if (!manifest) return undefined;
  if (canvasId !== undefined) return manifest.getSequences()[0].getCanvasById(canvasId);
  return manifest.getSequences()[0].getCanvasByIndex(canvasIndex);
});
export var getCurrentCanvas = createSelector([getManifestoInstance, getWindow], function (manifest, window) {
  if (!manifest || !window) return undefined;
  if (!window.canvasId) return manifest.getSequences()[0].getCanvasByIndex(0);
  return manifest.getSequences()[0].getCanvasById(window.canvasId);
});
/** */

export function getVisibleCanvases(state, args) {
  var canvas = getCurrentCanvas(state, _objectSpread({}, args));
  if (!canvas) return undefined;
  return getCanvasGrouping(state, _objectSpread({}, args, {
    canvasId: canvas.id
  }));
}
/**
* Return the current canvases grouped by how they'll appear in the viewer
* For book view returns groups of 2, for single returns 1
* @param {object} state
* @param {object} props
* @param {string} props.manifestId
* @param {string} props.windowId
* @return {Array}
*/

var getCanvasGroupings = createSelector([getCanvases, getWindowViewType], function (canvases, view) {
  return canvases && new CanvasGroupings(canvases, view).groupings();
});
/**
* Return the current canvases selected in a window
* For book view returns 2, for single returns 1
* @param {object} state
* @param {object} props
* @param {string} props.manifestId
* @param {string} props.windowId
* @return {Array}
*/

export var getCanvasGrouping = createSelector([getCanvasGroupings, function (state, _ref3) {
  var canvasId = _ref3.canvasId;
  return canvasId;
}], function (groupings, canvasId, view) {
  return groupings && groupings.find(function (group) {
    return group.some(function (c) {
      return c.id === canvasId;
    });
  }) || [];
});
/**
* Return the next canvas(es) for a window
* For book view returns 2, for single returns 1
* @param {object} state
* @param {object} props
* @param {string} props.manifestId
* @param {string} props.windowId
* @return {Array}
*/

export var getNextCanvasGrouping = createSelector([getCanvasGroupings, getCurrentCanvas], function (groupings, canvas, view) {
  if (!groupings) return undefined;
  var currentGroupIndex = groupings.findIndex(function (group) {
    return group.some(function (c) {
      return c.id === canvas.id;
    });
  });
  if (currentGroupIndex < 0 || currentGroupIndex + 1 >= groupings.length) return undefined;
  var newGroup = groupings[currentGroupIndex + 1];
  return newGroup;
});
/**
* Return the previous canvas(es) for a window
* For book view returns 2, for single returns 1
* @param {object} state
* @param {object} props
* @param {string} props.manifestId
* @param {string} props.windowId
* @return {Array}
*/

export var getPreviousCanvasGrouping = createSelector([getCanvasGroupings, getCurrentCanvas], function (groupings, canvas, view) {
  if (!groupings) return undefined;
  var currentGroupIndex = groupings.findIndex(function (group) {
    return group.some(function (c) {
      return c.id === canvas.id;
    });
  });
  if (currentGroupIndex < 1) return undefined;
  var newGroup = groupings[currentGroupIndex - 1];
  return newGroup;
});
/**
* Return canvas label, or alternatively return the given index + 1 to be displayed
* @param {object} canvas
* @return {String|Integer}
*/

export var getCanvasLabel = createSelector([getCanvas], function (canvas) {
  return canvas && (canvas.getLabel().length > 0 ? canvas.getLabel().map(function (label) {
    return label.value;
  })[0] : String(canvas.index + 1));
});
/**
* Return canvas description
* @param {object} canvas
* @param {String}
*/

export var getCanvasDescription = createSelector([getCanvas], function (canvas) {
  return canvas && canvas.getProperty('description');
});
/** */

export var selectInfoResponses = function selectInfoResponses(state) {
  return state.infoResponses;
};
export var selectInfoResponse = createSelector([getCanvas, selectInfoResponses], function (canvas, infoResponses) {
  return canvas && canvas.getImages()[0] && infoResponses[canvas.getImages()[0].getResource().getServices()[0].id] && !infoResponses[canvas.getImages()[0].getResource().getServices()[0].id].isFetching && infoResponses[canvas.getImages()[0].getResource().getServices()[0].id];
});
var authServiceProfiles = {
  clickthrough: true,
  external: true,
  kiosk: true,
  login: true
};
/**
 *
 */

export function selectNextAuthService(_ref4, resource) {
  var auth = _ref4.auth;
  var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : authServiceProfiles;
  var externalService = Utils.getService(_objectSpread({}, resource, {
    options: {}
  }), 'http://iiif.io/api/auth/1/external');

  if (externalService) {
    if (!auth[externalService.id]) {
      return filter.external && externalService;
    }

    if (auth[externalService.id].isFetching || auth[externalService.id].ok) return null;
  }

  var kioskService = Utils.getService(_objectSpread({}, resource, {
    options: {}
  }), 'http://iiif.io/api/auth/1/kiosk');

  if (kioskService) {
    if (!auth[kioskService.id]) {
      return filter.kiosk && kioskService;
    }

    if (auth[kioskService.id].isFetching || auth[kioskService.id].ok) return null;
  }

  var clickthroughService = Utils.getService(_objectSpread({}, resource, {
    options: {}
  }), 'http://iiif.io/api/auth/1/clickthrough');

  if (clickthroughService) {
    if (!auth[clickthroughService.id]) {
      return filter.clickthrough && clickthroughService;
    }

    if (auth[clickthroughService.id].isFetching || auth[clickthroughService.id].ok) return null;
  }

  var loginService = Utils.getService(_objectSpread({}, resource, {
    options: {}
  }), 'http://iiif.io/api/auth/1/login');

  if (loginService) {
    if (!auth[loginService.id]) {
      return filter.login && loginService;
    }
  }

  return null;
}
/** */

export function selectActiveAuthService(state, resource) {
  var loginService = Utils.getService(_objectSpread({}, resource, {
    options: {}
  }), 'http://iiif.io/api/auth/1/login');
  if (selectAuthStatus(state, loginService)) return loginService;
  var clickthroughService = Utils.getService(_objectSpread({}, resource, {
    options: {}
  }), 'http://iiif.io/api/auth/1/clickthrough');
  if (selectAuthStatus(state, clickthroughService)) return clickthroughService;
  var kioskService = Utils.getService(_objectSpread({}, resource, {
    options: {}
  }), 'http://iiif.io/api/auth/1/kiosk');
  if (selectAuthStatus(state, kioskService)) return kioskService;
  var externalService = Utils.getService(_objectSpread({}, resource, {
    options: {}
  }), 'http://iiif.io/api/auth/1/external');
  if (selectAuthStatus(state, externalService)) return externalService;
  return null;
}
export var selectCanvasAuthService = createSelector([selectInfoResponse, function (state) {
  return state;
}], function (infoResponse, state) {
  var resource = infoResponse && infoResponse.json;
  if (!resource) return undefined;
  return selectNextAuthService(state, resource) || selectActiveAuthService(state, resource);
});
/** */

export function selectAuthStatus(_ref5, service) {
  var auth = _ref5.auth;
  if (!service) return null;
  if (!auth[service.id]) return null;
  if (auth[service.id].isFetching) return 'fetching';
  if (auth[service.id].ok) return 'ok';
  return 'failed';
}